/**
 * #21 synosight — type de revenu d'une personne (shadow P&L), miroir de
 * `api/src/lib/revenueType.ts` : `Person.revenueType` s'il est posé, sinon règle
 * automatique (email @smile.fr / @smile-suisse.com → intercompanie ; autre
 * sous-traitant → external, @ext.smile.fr compris ; sinon interne).
 */
export const REVENUE_TYPE_LABELS = {
  INTERNAL: 'Interne Synotis CH',
  INTERCO: 'Intercompanie',
  EXTERNAL: 'External',
};

export function autoRevenueType(employeeType, email) {
  const domain = String(email ?? '').split('@')[1]?.trim().toLowerCase() ?? '';
  if (domain === 'smile.fr' || domain === 'smile-suisse.com') return 'INTERCO';
  if (employeeType === 'CONTRACTOR') return 'EXTERNAL';
  return 'INTERNAL';
}

/** Type effectif + origine (`auto` = déduit, le champ n'est pas posé). */
export function effectiveRevenueType(person) {
  if (person?.revenueType) return { type: person.revenueType, auto: false };
  return { type: autoRevenueType(person?.employeeType, person?.email), auto: true };
}
